var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative c welfare-card-package" },
    [
      _c(
        "el-card",
        { staticClass: "box-card", attrs: { shadow: "never" } },
        [
          _c("div", { staticClass: "breadcrumb" }, [
            _c("span", { staticClass: "breadcrumb-item" }, [
              _vm._v("福卡管理"),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "separator" }, [_vm._v(">")]),
            _vm._v(" "),
            _c("span", { staticClass: "breadcrumb-item current" }, [
              _vm._v("福卡权益包管理"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "filter-container" }, [
            _c(
              "div",
              { staticClass: "filter-left" },
              [
                _vm.debugCardList.length > 0
                  ? _c(
                      "el-select",
                      {
                        staticClass: "filter-item",
                        attrs: {
                          placeholder: "请选择包含卡片",
                          clearable: "",
                          "popper-class": "custom-select",
                          size: "medium",
                        },
                        model: {
                          value: _vm.pageFrom.cardId,
                          callback: function ($$v) {
                            _vm.$set(_vm.pageFrom, "cardId", $$v)
                          },
                          expression: "pageFrom.cardId",
                        },
                      },
                      _vm._l(_vm.debugCardList, function (item) {
                        return _c("el-option", {
                          key: item.id,
                          attrs: { label: item.name, value: item.id },
                        })
                      }),
                      1
                    )
                  : _c(
                      "el-button",
                      {
                        staticClass: "filter-item load-filter-btn",
                        attrs: {
                          type: "info",
                          plain: "",
                          size: "medium",
                          icon: "el-icon-menu",
                        },
                        on: { click: _vm.loadCardFilter },
                      },
                      [_vm._v("加载卡片筛选")]
                    ),
                _vm._v(" "),
                _c(
                  "el-input",
                  {
                    staticClass: "filter-item",
                    attrs: {
                      placeholder: "请输入福利卡包名称或内部名称",
                      clearable: "",
                      size: "medium",
                    },
                    model: {
                      value: _vm.pageFrom.keyword,
                      callback: function ($$v) {
                        _vm.$set(_vm.pageFrom, "keyword", $$v)
                      },
                      expression: "pageFrom.keyword",
                    },
                  },
                  [
                    _c("i", {
                      staticClass: "el-input__icon el-icon-search search-icon",
                      attrs: { slot: "prefix" },
                      slot: "prefix",
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "filter-item search-btn",
                    attrs: { type: "primary", icon: "el-icon-search" },
                    on: { click: _vm.search },
                  },
                  [_vm._v("搜索")]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "filter-right" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "action-btn",
                    attrs: {
                      type: "primary",
                      size: "medium",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.openAddDialog },
                  },
                  [_vm._v("新建卡包")]
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "table",
              staticClass: "custom-table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.list,
                border: false,
                "cell-style": _vm.tableRowStyle,
                "header-cell-style": _vm.tableHeaderStyle,
                "empty-text": "暂无数据",
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  "min-width": "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "name",
                  label: "福利卡包名称",
                  "min-width": "140",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "internalName",
                  label: "内部名称",
                  "min-width": "120",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "状态", "min-width": "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            staticClass: "status-tag",
                            attrs: {
                              type: scope.row.status == 1 ? "success" : "info",
                              size: "mini",
                              effect: "light",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.formatStatus(scope.row)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "包含卡片", "min-width": "200" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.cards && scope.row.cards.length
                          ? _c(
                              "div",
                              { staticClass: "card-list" },
                              _vm._l(scope.row.cards, function (card) {
                                return _c(
                                  "el-tag",
                                  {
                                    key: card.id,
                                    staticClass: "card-tag",
                                    attrs: {
                                      size: "small",
                                      effect: "plain",
                                      type: "primary",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(card.name) +
                                        "\n            "
                                    ),
                                  ]
                                )
                              }),
                              1
                            )
                          : _c("span", { staticClass: "no-data" }, [
                              _vm._v("--"),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "150",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "100",
                  align: "center",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            _c(
                              "el-tooltip",
                              { attrs: { content: "编辑", placement: "top" } },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon",
                                  attrs: { type: "text", icon: "el-icon-edit" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openEditDialog(scope.row)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-tooltip",
                              { attrs: { content: "删除", placement: "top" } },
                              [
                                _c("el-button", {
                                  staticClass: "action-icon delete-icon",
                                  staticStyle: { color: "#F56C6C" },
                                  attrs: {
                                    type: "text",
                                    icon: "el-icon-delete",
                                    disabled: scope.row.hasIssuedCards,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openDeleteConfirm(scope.row.id)
                                    },
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("div", { staticClass: "pagination-info" }, [
                _c("span", { staticClass: "pagination-text" }, [
                  _vm._v(
                    "共 " + _vm._s(_vm.tableData.total) + " 条记录，每页显示"
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-pagination", {
                staticClass: "custom-pagination",
                attrs: {
                  "current-page": _vm.pageFrom.page,
                  "page-sizes": [20, 40, 80, 100],
                  "page-size": _vm.pageFrom.limit,
                  layout: "sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "福卡权益包" + _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "680px",
            "close-on-click-modal": false,
            "before-close": _vm.handleClose,
            center: "",
            "custom-class": "custom-dialog",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "dialog-inner-wrapper" },
            [
              _c(
                "el-form",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "form",
                  staticClass: "dialog-form",
                  attrs: {
                    model: _vm.form,
                    rules: _vm.rules,
                    "label-width": "140px",
                    "label-position": "right",
                    size: "medium",
                  },
                },
                [
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "福卡权益包名称:", prop: "name" } },
                        [
                          _c("el-input", {
                            staticClass: "form-input",
                            attrs: { placeholder: "请输入福卡权益包名称" },
                            model: {
                              value: _vm.form.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "name", $$v)
                              },
                              expression: "form.name",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "内部名称:", prop: "internalName" } },
                        [
                          _c("el-input", {
                            staticClass: "form-input",
                            attrs: { placeholder: "请输入福卡权益包内部名称" },
                            model: {
                              value: _vm.form.internalName,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "internalName", $$v)
                              },
                              expression: "form.internalName",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "权益包状态:", prop: "status" } },
                        [
                          _c("el-switch", {
                            attrs: {
                              "active-color": "#409EFF",
                              "inactive-color": "#DCDFE6",
                            },
                            model: {
                              value: _vm.switchValue,
                              callback: function ($$v) {
                                _vm.switchValue = $$v
                              },
                              expression: "switchValue",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "包含卡片:", prop: "cardIds" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-select",
                              attrs: {
                                multiple: "",
                                filterable: "",
                                placeholder: "请选择权益包对应的卡片",
                                "value-key": "id",
                                "collapse-tags": false,
                                "popper-class": "card-select-dropdown",
                              },
                              model: {
                                value: _vm.form.cardIds,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "cardIds", $$v)
                                },
                                expression: "form.cardIds",
                              },
                            },
                            _vm._l(_vm.debugCardList, function (item) {
                              return _c("el-option", {
                                key: item.id,
                                attrs: {
                                  label: item.name,
                                  value: Number(item.id),
                                },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "兑换页配置:",
                            prop: "exchangeConfigId",
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "form-select",
                              attrs: {
                                placeholder: "请选择兑换配置页面",
                                filterable: "",
                                remote: "",
                                "remote-method": _vm.searchExchangeConfigs,
                                loading: _vm.exchangeConfigsLoading,
                                "popper-class": "exchange-config-dropdown",
                              },
                              on: { focus: _vm.loadExchangeConfigs },
                              model: {
                                value: _vm.form.exchangeConfigId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "exchangeConfigId", $$v)
                                },
                                expression: "form.exchangeConfigId",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "select-header",
                                  attrs: { slot: "prefix" },
                                  slot: "prefix",
                                },
                                [
                                  _vm.exchangeConfigsLoading
                                    ? _c("i", {
                                        staticClass: "el-icon-loading",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.exchangePageOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.value + "-" + item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              _vm._v(" "),
                              _vm.exchangePageTotal > 0
                                ? _c(
                                    "div",
                                    { staticClass: "select-pagination" },
                                    [
                                      _c("el-pagination", {
                                        attrs: {
                                          "current-page":
                                            _vm.exchangePageParams.page,
                                          "page-size":
                                            _vm.exchangePageParams.limit,
                                          layout: "prev, pager, next",
                                          total: _vm.exchangePageTotal,
                                          small: "",
                                          background: "",
                                        },
                                        on: {
                                          "current-change":
                                            _vm.handleExchangePageChange,
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "form-tip" }, [
                            _vm._v("不选择展示默认配置"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "卡片样式:", prop: "cardStyle" } },
                        [
                          _c("div", { staticClass: "upload-box" }, [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "upLoadPicBox",
                                    on: {
                                      click: function ($event) {
                                        return _vm.modalPicTap("1", "cardStyle")
                                      },
                                    },
                                  },
                                  [
                                    _vm.form.cardStyle
                                      ? _c("div", { staticClass: "pictrue" }, [
                                          _c("img", {
                                            staticClass: "card-preview",
                                            attrs: { src: _vm.form.cardStyle },
                                          }),
                                        ])
                                      : _c("div", { staticClass: "upLoad" }, [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-plus upload-icon",
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "upload-tip" },
                                            [_vm._v("点击上传图片")]
                                          ),
                                        ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.form.cardStyle
                                  ? _c("i", {
                                      staticClass: "el-icon-delete",
                                      staticStyle: {
                                        color: "red",
                                        "font-size": "16px",
                                        "margin-left": "10px",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeImg("cardStyle")
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "主题色:", prop: "themeColor" } },
                        [
                          _c("div", { staticClass: "color-selection" }, [
                            _c(
                              "div",
                              { staticClass: "color-picker-wrapper" },
                              [
                                _c("el-color-picker", {
                                  staticClass: "theme-color-picker",
                                  attrs: { "show-alpha": "" },
                                  model: {
                                    value: _vm.form.themeColor,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "themeColor", $$v)
                                    },
                                    expression: "form.themeColor",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", {
                                  staticClass: "color-preview",
                                  style: {
                                    backgroundColor: _vm.form.themeColor,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-section" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "使用说明:", prop: "usageDesc" } },
                        [
                          _c("el-input", {
                            staticClass: "form-textarea",
                            attrs: {
                              type: "textarea",
                              placeholder: "请输入",
                              rows: 4,
                              resize: "none",
                            },
                            model: {
                              value: _vm.form.usageDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "usageDesc", $$v)
                              },
                              expression: "form.usageDesc",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { plain: "" },
                  on: { click: _vm.handleClose },
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "确认删除",
            visible: _vm.confirmDeleteVisible,
            width: "400px",
            center: "",
            "custom-class": "delete-dialog",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.confirmDeleteVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "delete-confirm-content" }, [
            _c("p", { staticClass: "delete-message" }, [
              _vm._v("确定要删除该福卡包吗？删除后无法恢复。"),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "cancel-btn",
                  attrs: { plain: "" },
                  on: {
                    click: function ($event) {
                      _vm.confirmDeleteVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "confirm-btn",
                  attrs: { type: "danger" },
                  on: { click: _vm.confirmDelete },
                },
                [_vm._v("确认删除")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }